import React, {useState} from 'react';
import {Waypoint} from 'react-waypoint';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_LEFT__16} from '@homeaway/svg-defs';
import {Link} from 'react-router-dom';

export function useWaypoints({
    sections = [],
    withBack = {href: '/careers', label: 'Careers'},
    withButton = false,
}) {
    const indexOffset = withBack ? 1 : 0;
    const [active, setActive] = useState(indexOffset);
    const [visible, setVisibility] = useState(false);

    let buttonWaypoint;
    let links = [];
    let waypoints = [];

    if (withButton) {
        buttonWaypoint = (
            <Waypoint
                onEnter={() => {
                    if (visible) {
                        setVisibility(false);
                    }
                }}
                onLeave={() => {
                    if (!visible) {
                        setVisibility(true);
                    }
                }}
            />
        );
    }

    if (withBack) {
        links.push({
            label: withBack.label,
            href: withBack.href,
            node: (
                <Link to={withBack.href}>
                    <SVGIcon markup={CHEVRON_LEFT__16} /> {withBack.label}
                </Link>
            ),
        });
    }

    if (sections.length) {
        waypoints = sections.map((section, index) => {
            return (
                <Waypoint
                    onEnter={({previousPosition}) => {
                        if (previousPosition === 'above' && index > 0) {
                            setActive(index + indexOffset - 1);
                        }
                    }}
                    onLeave={({currentPosition}) => {
                        if (currentPosition === 'above') {
                            setActive(index + indexOffset);
                        }
                    }}
                    topOffset={80}
                />
            );
        });

        links.push(
            ...sections.map(({link, text}) => {
                if (link.startsWith('/')) {
                    return {
                        href: link,
                        label: text,
                        node: <Link to={link}>{text}</Link>,
                    };
                }

                return {
                    href: link,
                    label: text,
                };
            }),
        );
    }

    return {links, waypoints, buttonWaypoint, visible, active};
}
